import { toMoney } from './to-money.js';
const MONEY_FORMAT = {
    precision: 0,
    separator: '.',
    delimiter: ',',
    unit: '$',
    showSignal: true,
};
const MONEY_WITH_CENTS_FORMAT = Object.assign(Object.assign({}, MONEY_FORMAT), { precision: 2 });
export const toUsdMoney = (amountInDollars) => toMoney(amountInDollars !== null && amountInDollars !== void 0 ? amountInDollars : '', MONEY_FORMAT);
export const toUsdMoneyWithCents = (amountInDollars) => toMoney(amountInDollars !== null && amountInDollars !== void 0 ? amountInDollars : '', MONEY_WITH_CENTS_FORMAT);
//# sourceMappingURL=to-usd-money.js.map